module.exports = __webpack_public_path__ + "679ed4912e457f5b8d4f5e37c18e0268.svg";